export const inputGroupStyle = ({ spacing, palette }) => `
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;

  .fill-info {
    margin-left: auto;
    margin-bottom: 8px;

    i {
      color: #6e798e;
    }
  }
`

export const labelWrapperStyle = () => `
  position: relative;
  height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const inputStyle = (hasError, hasIcon) => {
  const fontColor = '#223254';
  const disabledColor = '#f4f5f7';
  const errorRed = '#e40e31';
  const spacing16 = '16px';

  return (`
    box-sizing: border-box;
    width: 100%;
    min-height: 100px;
    resize: vertical;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    border-radius: 4px;
    caret-color: #1abc9c;
    border: 1px solid ${hasError ? errorRed : '#c8ccd4'};
    color: ${hasError ? errorRed : fontColor};
    padding: ${spacing16} ${hasIcon || hasError ? '40px' : spacing16} ${spacing16} ${spacing16};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
    scrollbar-width: thin;

    ::-webkit-scrollbar {
      width: 14px;
      height: 18px;
    }
    
    ::-webkit-scrollbar-thumb {
      height: 6px;
      border: 3px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      border-radius: 7px;
      background-color: rgba(0, 0, 0, 0.15);
      box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.3);
    }

    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }

    &:focus {
      color: ${fontColor};
      outline: 1px solid transparent;
      border: 1px solid ${hasError ? errorRed : '#9098a9'};
    }
    &:disabled {
      background-color: ${disabledColor};
      color: ${fontColor};
      pointer-events: none;      
    }
    &:disabled + i {
      color: ${fontColor};
    }

    &::placeholder { 
      opacity: 1;
      font-weight: 500;
    }
  `)
}

export const errorMessageStyle = () => `
  color: #e40e31;
  margin-top: 4px;
  display: block;
  font-weight: 600;
  font-size: 12px;
  min-height: 16px;
  width: 100%;
`

export const iconClass = (hasError, label) => `
  position: absolute;
  top: ${label ? '44px' : '12px'};
  right: 0;
  line-height: 48px !important;
  width: 24px;
  height: 48px;
  font-size: 24px;
  text-align: center;
  pointer-events: none;
  margin-right: 16px;
  color: ${hasError ? '#e40e31' : '#1abc9c'};
`
